
export type BrandSegmentKind = "owned" | "agency" | "licensed" | "other";

export function classifyBrandSegment(asset: any): BrandSegmentKind {
  const category = (asset.category ?? "").toString().trim();
  const group = (asset.group ?? "").toString().trim();
  const segment = (asset.segment ?? "").toString().trim();

  // ---------- 1. Priority: Check 'category' (New CSV Standard) ----------
  
  // Owned
  if (category === "House Brand" || category === "自有品牌") {
    return "owned";
  }

  // Agency
  if (category === "Licensed Brand" || category === "代理品牌") {
    return "agency";
  }

  // Licensed (IP / Co-brand)
  if (
    category === "IP" ||
    category === "IP授權／合作" ||
    category === "Co-brand"
  ) {
    return "licensed";
  }

  // ---------- 2. Fallback: Check 'group' (Legacy Data) ----------
  if (group === "IP") return "licensed";
  if (group === "House Brand" || group === "自有品牌") return "owned";
  if (group === "Licensed Brand" || group === "代理品牌") return "agency";

  // ---------- 3. Fallback: Keyword Search ----------
  const combined = (category + segment + group).replace(/\s/g, "");
  if (combined.includes("自有")) return "owned";
  if (combined.includes("代理")) return "agency";
  if (combined.includes("授權") || combined.toLowerCase().includes("ip")) return "licensed";

  // Default
  return "other";
}

export const SEGMENT_LABELS: Record<BrandSegmentKind, string> = {
    owned: "自有品牌",
    agency: "代理品牌",
    licensed: "授權 & 在地聯名",
    other: "未分類"
};

export const SEGMENT_COLORS: Record<BrandSegmentKind, string> = {
    owned: "#2563eb",   // Blue
    agency: "#d97706",  // Orange
    licensed: "#10b981",// Green
    other: "#666"       // Gray
};
